<template>
  <a-button
    icon="edit"
    size="small"
    type="link"
    :disabled="disabled"
    @click="e => $emit('click', e)"
    style="color: #faad14"
  >
    编辑
  </a-button>
</template>

<script>
export default {
  name: 'EditButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
